import React from "react";
import TableRow from "./TableRow";
import "./style.css";

function Table({ data }) {
  return (
    <div className="student-list_">
      {data.length > 0 ? (
        data.map((item, index) => (
          <TableRow data={item} index={index} key={index} />
        ))
      ) : (
        <span style={{display:"flex",justifyContent:"center",fontSize:"2.5rem",color:"white"}}>No Result Found</span>
      )}
    </div>
  );
}

export default Table;
